import React, { memo } from 'react'
import { array } from 'prop-types'
import serverData from '../utils/server-data'
import { Col, HeadingText } from '@paypalcorp/pp-react'
import SubSections from './SubSections'

const Sections = memo((props) =>
  props.sections.map(
    ({
      sectionId,
      sectionName,
      hasElmoTreatment,
      subSections = [],
      isEnabled,
    }) =>
      isEnabled &&
      hasElmoTreatment && (
        <div
          className={`merchant-section-container ${
            serverData.isNative ? 'merchant-native' : ''
          }`}
          key={sectionName}
          id={sectionId}
        >
          <Col>
            <HeadingText
              id={`${sectionId}Header`}
              size="sm"
              className="merchant-section-header"
            >
              {sectionName}
            </HeadingText>
            <SubSections subSections={subSections} {...props} />
          </Col>
        </div>
      ),
  ),
)

Sections.propTypes = {
  sections: array,
}

Sections.defaultProps = {
  sections: [],
}

Sections.displayName = 'Sections'

export default Sections
